import React from 'react'
import PropTypes from 'prop-types'
import renderReact from 'utils/renderReact'

import SignUp from 'components/authentication/forms/SignUp'
import ExternalLayout from 'layouts/ExternalLayout'
import withBaseHelper from 'utils/withBaseHelper'

const Register = props => (
  <ExternalLayout id="external-container" {...props}>
    <SignUp />
  </ExternalLayout>
)

Register.propTypes = { locale: PropTypes.string }
Register.defaultProps = { locale: 'en' }

renderReact('Register', withBaseHelper(Register))
export default withBaseHelper(Register)
